module.exports = __webpack_public_path__ + "assets/img/project-stepCounter-thumb.371314c3.png";